import React, { Component } from "react";
import PropTypes from "prop-types";
import { Bar } from "react-chartjs-2";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as dashboardActions from "../dashboardActions";
import {
  getSecurityAlertsLastWeek,
  getSecurityAlertsLastWeekIsLoading
} from "../dashboardSelector";
import WidgetErrorMessage from "./WidgetErrorMessage";
import WidgetReloader from "./WidgetReloader";
import * as types from "../dashboardActionTypes";
import severityLevel from "../../common/severityConfig";
import Spinner from "../../common/progress/Spinner";
import { translate } from "react-i18next";
import Widget from "./Widget";
import WidgetOverlayLinkToTa from "./WidgetOverlayLinkToTa";

class SecurityAlertsLastWeekWidget extends Component {
  constructor(props) {
    super(props);
    this.onReload = this.onReload.bind(this);
  }

    componentDidMount() {
        if (this.props.customerInformation.siem != "wazuh") {
            this.props.actions.loadSecurityAlertsLastWeek();
        }
  }

  onReload() {
      if (this.props.customerInformation.siem != "wazuh") {
          this.props.actions.loadSecurityAlertsLastWeek();
      }
  }

  render() {
      const { customerInformation, errors, isLoading, securityAlertsLastWeek, t } = this.props;
    const options = {
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            stacked: true,
            barThickness: 14,
            scaleLabel: {
              display: true,
              labelString: "Date"
            },
            gridLines: {
              display: false
            }
          }
        ],
        yAxes: [
          {
            stacked: true,
            scaleLabel: {
              display: true,
              labelString: "Count"
            },
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 10,
              callback: function(tick, index, ticks) {
                if (tick.toString().indexOf(".") !== -1) return null;

                return tick.toLocaleString();
              }
            }
          }
        ]
      },
      maintainAspectRatio: false
      };

      
      const datasetsMock = [
          {
              type: "bar",
              label: 0,
              data: [5, 2, 7, 1, 2, 2, 3],
              backgroundColor: "#2cbafc"
          },
          {
              type: "bar",
              label: 1,
              data: [3, 7, 9, 1, 2, 3, 1],
              backgroundColor: "#fd9e29"
          },
          {
              type: "bar",
              label: 2,
              data: [2, 1, 3, 1, 1, 2, 3],
              backgroundColor: "#d419a8"
          }
      ];

      const labelsMock =  [ "14/6", "15/6", "16/6", "17/6", "18/6","19/6","20/6"] ;
      const mock =  {
          labels: labelsMock,
          datasets: datasetsMock
      }

    const lastWeekError = errors.filter(
      err => err.key === types.LOAD_SECURITY_ALERTS_FOR_LAST_WEEK_FAILED
    );
    const hasErrors = lastWeekError.length > 0;
    {
      /*const errorMessage = hasErrors ? lastWeekError[0].message : "";*/
      }

      if (customerInformation.siem === "wazuh") {
          return (
              <Widget
                  header={t("securityAlertsLastWeekWidgetTitle")}
                  onReload={this.onReload}
              >
                  <WidgetOverlayLinkToTa buttonText={t("logInToTa")} taUrl={customerInformation.technicalAnalysisUrl} />

                  <div className="bar-chart">
                      <Bar data={mock} options={options} />
                  </div>
              </Widget>
          );
      }

    if (isLoading) {
      return (
        <Widget
          header={t("securityAlertsLastWeekWidgetTitle")}
          onReload={this.onReload}
          isLoading={isLoading}
        >
          <div className="pie-wrapper align-center">
            <div className="text-center">
              <Spinner />
            </div>
          </div>
        </Widget>
      );
      }
     
    if (hasErrors) {
      return (
        <div className="widget">
          <h2 className="text-center">
            {t("securityAlertsLastWeekWidgetTitle")}
          </h2>
          <div className="overlay overlay-default">
            <WidgetErrorMessage onClick={this.onReload} />
          </div>
        </div>
      );
    } else {
      return (
        <div className="widget">
          <WidgetReloader onClick={this.onReload} />
          <h2 className="text-center">
            {t("securityAlertsLastWeekWidgetTitle")}
          </h2>
          <div className="bar-chart">
            <Bar data={securityAlertsLastWeek} options={options} />
          </div>
        </div>
      );
    }
  }
}

SecurityAlertsLastWeekWidget.propTypes = {
  errors: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  actions: PropTypes.object.isRequired,
  securityAlertsLastWeek: PropTypes.object.isRequired,
  customerInformation: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    errors: state.errors,
    isLoading: getSecurityAlertsLastWeekIsLoading(state),
    securityAlertsLastWeek: getSecurityAlertsLastWeek(state),
    customerInformation: state.customerInformation
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(dashboardActions, dispatch)
  };
};

export default translate("translations")(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SecurityAlertsLastWeekWidget)
);



// WEBPACK FOOTER //
// ./src/dashboard/widgets/SecurityAlertsLastWeekWidget.js